module.exports = __webpack_public_path__ + "da1e4b333baf8a2a1190196feab116ba.svg";